import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminProtectedRoute = () => {
  const { adminUser } = useAuth();
  const location = useLocation();

 // console.log("AdminProtectedRoute: Checking adminUser:", adminUser, "location:", location.pathname);

  if (!adminUser) {
 //   console.log("AdminProtectedRoute: No adminUser, redirecting to /admin");
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

 // console.log("AdminProtectedRoute: adminUser found, allowing access");

  return (
    <>
    <style>{`
      body{
        background-color: transparent !important;
       }
       `}</style>
     <Outlet />
  </>
  );

};

export default AdminProtectedRoute;
